<template lang="pug">
input(
  :type="type",
  :maxlength="maxlength",
  :fieldType="fieldType",
  :compname="compname",
  :phoneFormat="phoneFormat",
  :isCountryCodeEnabled="isCountryCodeEnabled",
  :id="id",
  :name="name",
  :value="value",
  :placeholder="placeholder",
  @input="updateValue"
)
</template>

<script>
import { parsePhoneNumberFromString } from "libphonenumber-js";
export default {
  name: "FormInput",
  props: {
    value: { type: String, required: true },
    type: { type: String, required: true },
    name: { type: String, required: true },
    placeholder: { type: String, required: false },
    id: { type: String, required: true },
    maxlength: { type: String, required: false },
    fieldType: { type: String, required: false },
    compname: { type: String, required: false },
    phoneFormat: { type: String, required: false },
    isCountryCodeEnabled: { type: String, required: false },
  },
  methods: {
    updateValue: function (e) {
      const id = this.id;
      let result = { id: id, bool: false, message: "" };
      const value = e.target.value;
      // nameで行けるか検討
      if (id === "nameLast") {
        if (value === "") {
          result.id = "nameLast";
          result.message = "姓が入力されていません";
        } else {
          result.bool = true;
          // GTMで利用するためにバリデーション通過後の値をdataLayer変数として格納
          // GTMで比較する際に文字列比較のため文字列に変換
          const hasKatakanaLast = /[ァ-ヶー]/.test(value) ? "1" : "0";
          const hasAlphabetLast = /[A-Za-z]/.test(value) ? "1" : "0";
          sessionStorage.setItem("hasKatakanaLast", hasKatakanaLast);
          sessionStorage.setItem("hasAlphabetLast", hasAlphabetLast);
        }
      }

      if (id === "nameFirst") {
        if (value === "") {
          result.id = "nameFirst";
          result.message = "名が入力されていません";
        } else {
          result.bool = true;
          // GTMで利用するためにバリデーション通過後の値をdataLayer変数として格納
          // GTMで比較する際に文字列比較のため文字列に変換
          const hasKatakanaFirst = /[ァ-ヶー]/.test(value) ? "1" : "0";
          const hasAlphabetFirst = /[A-Za-z]/.test(value) ? "1" : "0";
          sessionStorage.setItem("hasKatakanaFirst", hasKatakanaFirst);
          sessionStorage.setItem("hasAlphabetFirst", hasAlphabetFirst);
        }
      }

      if (id === "international_PhoneNumber_countrycode") {
        const parsedPhoneNumber = parsePhoneNumberFromString(value, "JP");
        if (value === "") {
          result.message = "携帯電話番号が入力されていません";
        } else if (
          parsedPhoneNumber === undefined ||
          !parsedPhoneNumber.isValid()
        ) {
          result.message = "携帯電話番号の値が不正です";
        } else {
          result.bool = true;
        }
      }

      if (id === "mail") {
        const regex =
          /^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        if (value === "") {
          result.message = "メールアドレスが入力されていません";
        } else if (!regex.test(value)) {
          result.message = "メールアドレスの値が不正です";
        } else {
          result.bool = true;
        }
      }
      this.$emit("checkValidate", result);
      this.$emit("input", value);
    },
  },
};
</script>
